import { useLocation } from 'react-router-dom';

import { NavItem, NavLink } from './Styled';

type NavItemWrapperProps = {
  to?: string;
  label?: string;
};

const NavItemWrapper = ({
  to,
  label,
  ...props
}: Readonly<NavItemWrapperProps>) => {
  const location = useLocation();
  const isSelected = location.pathname.endsWith(to);

  return (
    <NavLink to={to} role="tab" aria-selected={isSelected} {...props}>
      <NavItem selected={isSelected}>{label}</NavItem>
    </NavLink>
  );
};

export default NavItemWrapper;
